import { id } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";

// Dummy data
const note = [
  `Speed Shopping promo is a point-based initiative for the youth segment.`,
  `This Promo is exclusive to MTN Pulse customers only.`,
  `Customer gains 1 point for every five pesewas spent (GHC 0.05) on mashup via myMTN Application.`,
  `Accrued points are not transferable to another MTN subscriber.`,
  `Usage of mashup bundles do not accrue points.`,
  `Usage from main account do not accrue points.`,
];

const tips = [
  "Promo Starts from 15th Nov to 15th Dec, 2023",
  "Winners will be notified via in-app Notification & Phone call",
  "Check points by clicking loyalty or leaderboard",
];

const useSpeedShopping = () => {
  const { themeContext, theme } = useTheme();
  const [cartQuantity, setCartQuantity] = useState(0);
  const [cartCost, setCartCost] = useState(0);
  const [showLimitDialog, setShowLimitDialog] = useState(false);
  const [token, setToken] = useState(null);
  const [itemToRemove, setItemToRemove] = useState(null);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(null);

  const {
    selectedLoyaltyData,
    speedShoppingController: { state, dispatch },
    timerFunc,
    speedShoppingData,
    getSpeedShoppingData,
    shoppingCartSaveStatus,
    saveShoppingCart,
  } = useLoyalty();
  const { items } = state;
  const { promoData: { bannerImage, tailImage, bannerAd } = {} } =
    selectedLoyaltyData || {};
  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const addItemToCart = (id) => {
    dispatch({ type: "addToCart", id });
  };

  const confirmDeleteItem = () => {
    dispatch({ type: "decrement", id: itemToRemove }) ;
  };

  const decreaseCartItem = (id) => {
    const item = items.find(({id: itemId}) => itemId === id);
    if (item.quantity < 2) {
      setItemToRemove(id);
      setShowDeleteConfirmModal(true);
      return;
    }
    dispatch({ type: "decrement", id });
  };

  useEffect(() => {
    if (items && Array.isArray(items)) {
      setCartQuantity(
        items.reduce((prev, cur) => {
          return prev + (cur?.quantity || 0);
        }, 0)
      );

      setCartCost(
        items.reduce((prev, cur) => {
          return prev + (cur?.quantity * cur?.price || 0);
        }, 0)
      );
    }
  }, [items]);

  const processShoppingCart = ({ region, officeLocation }) => {
    const payload = {
      items: items.filter((item) => item.quantity > 0),
      pickup: `${officeLocation}, ${region}`,
    };
    saveShoppingCart(payload);
  };

  useEffect(() => {
    const t = JSON.parse(localStorage.getItem("token"));
    setToken(t);
  }, []);

  return {
    background,
    history,
    bannerImage,
    bannerAd,
    tailImage,
    tips,
    note,
    items,
    cartQuantity,
    addItemToCart,
    decreaseCartItem,
    timerFunc,
    speedShoppingData,
    getSpeedShoppingData,
    shoppingCartSaveStatus,
    processShoppingCart,
    token,
    cartCost,
    setShowLimitDialog,
    showLimitDialog,
    showDeleteConfirmModal,
    confirmDeleteItem,
    setShowDeleteConfirmModal,
  };
};

export default useSpeedShopping;
